@if (isLoading) {
<app-spinner [isLoading]="isLoading" />
} @else if (isEditMode) {
<form class="section" [formGroup]="form">
  <div class="heading-wrapper">
    <h4>{{ 'pages.client.general.title' | translate }}</h4>
    <div class="actions d-flex">
      <button class="primary" (click)="submit()">
        {{ 'pages.client.saveChanges' | translate }}
      </button>
      <button class="secondary cancel" (click)="setIsEditMode(false, !hasFormChanged)">
        {{ 'pages.client.cancel' | translate }}
      </button>
    </div>
  </div>
  <div class="first-grid">
    <div class="name-wrapper">
      <div class="label-wrapper">
        <label class="form-label lna" for="name">
          {{ 'pages.client.name' | translate }}
          <span class="required-field">*</span>
        </label>
        <app-tooltip text="userName" />
      </div>
      <input class="form-control lna" id="name" [ngClass]="{
            invalid: this.shouldRenderError('name') && name?.errors
          }" type="text" formControlName="name" name="name" required />
      <div class="error-wrapper">
        @if (this.shouldRenderError('name') && name?.errors) {
        @if (name?.errors?.['required']) {
        <small class="error-message">
          {{ 'components.form.errorRequired' | translate }}
        </small>
        } @else if (name?.errors?.['minlength']) {
        <small class="error-message">
          {{
          'components.form.minLength'
          | translate
          : {
          minLength: name?.errors?.['minlength']['requiredLength']
          }
          }}
        </small>
        } @else if (name?.errors?.['maxlength']) {
        <small class="error-message">
          {{
          'components.form.maxLength'
          | translate
          : {
          maxLength: name?.errors?.['maxlength']['requiredLength']
          }
          }}
        </small>
        }
        }
      </div>
    </div>
    <div class="surname-wrapper">
      <div class="label-wrapper">
        <label class="form-label lna" for="surname">
          {{ 'pages.client.surname' | translate }}
          <span class="required-field">*</span>
        </label>
        <app-tooltip text="userSurname" />
      </div>
      <input class="form-control lna" id="surname" [ngClass]="{
            invalid: this.shouldRenderError('surname') && surname?.errors
          }" type="text" formControlName="surname" name="surname" required />
      <div class="error-wrapper">
        @if (this.shouldRenderError('surname') && surname?.errors) {
        @if (surname?.errors?.['required']) {
        <small class="error-message">
          {{ 'components.form.errorRequired' | translate }}
        </small>
        } @else if (surname?.errors?.['minlength']) {
        <small class="error-message">
          {{
          'components.form.minLength'
          | translate
          : {
          minLength: surname?.errors?.['minlength']['requiredLength']
          }
          }}
        </small>
        } @else if (surname?.errors?.['maxlength']) {
        <small class="error-message">
          {{
          'components.form.maxLength'
          | translate
          : {
          maxLength: surname?.errors?.['maxlength']['requiredLength']
          }
          }}
        </small>
        }
        }
      </div>
    </div>
    <div class="birthday-wrapper">
      <div class="label-wrapper">
        <label class="form-label lna" for="birthday">
          {{ 'pages.client.birthday' | translate }}
          <span class="required-field">*</span>
        </label>
      </div>
      <app-date-picker [date]="birthday?.value" [invalid]="shouldRenderError('birthday')"
        [dateRangeMode]="dateRangeMode.Past" (dateSelected)="onDateSelected($event, 'birthday')" />
      @if (this.shouldRenderError('birthday') && birthday?.errors) {
      @if (birthday?.errors?.['required']) {
      <small class="error-message">
        {{ 'components.form.errorRequired' | translate }}
      </small>
      }
      }
    </div>
    <div class="country-wrapper">
      <div class="label-wrapper">
        <label class="form-label lna" for="countryId">
          {{ 'pages.client.country' | translate }}
          <span class="required-field">*</span>
        </label>
        <app-tooltip text="userCountryId" />
      </div>
      <select id="countryId" [ngClass]="{
            invalid: this.shouldRenderError('countryId') && countryId?.invalid && (countryId?.touched || submitAttempted)
          }" (blur)="onCountryBlur()" formControlName="countryId">
        <option class="empty-option" [value]="-1" [selected]="true" disabled>
          {{ 'pages.client.chooseCountry' | translate }}
        </option>
        @for (country of countries; track country.id) {
        <option [value]="country.id">{{ country.name }}</option>
        }
      </select>
      <div class="error-wrapper">
        @if (this.shouldRenderError('countryId') && countryId?.invalid) {
        @if (countryId?.errors?.['min']) {
        <small class="error-message">
          {{ 'components.form.errorRequired' | translate }}
        </small>
        }
        }
      </div>
      <div class="error-wrapper">
        @if (this.shouldRenderError('countryId') && countryId?.invalid) {
        @if (countryId?.errors?.['invalidCountry']) {
        <small class="error-message">
          {{ 'components.form.errorRequired' | translate }}
        </small>
        }
        }
      </div>
    </div>
    <div></div>
    <div></div>
    <div class="officialDocumentId-wrapper">
      <div class="label-wrapper">
        <label class="form-label lna" for="officialDocumentId">
          {{ 'pages.client.officialDocumentId' | translate }}
          @if (isIdVerifiedInPerson?.value) {
          <span class="required-field">*</span>
          }
        </label>
        <app-tooltip text="officialDocumentId" />
      </div>
      <input class="form-control lna" id="officialDocumentId" [ngClass]="{
                        invalid: this.shouldRenderError('officialDocumentId') && officialDocumentId?.errors
                      }" [attr.aria-required]="isIdVerifiedInPerson?.value" type="text" [maxlength]="50"
        formControlName="officialDocumentId" name="officialDocumentId" />
      <div class="error-wrapper">
        @if (this.shouldRenderError('officialDocumentId') && officialDocumentId?.errors) {
        @if (officialDocumentId?.errors?.['required']) {
        <small class="error-message">
          {{ 'components.form.errorRequired' | translate }}
        </small>
        }
        }
      </div>
    </div>
    <div class="inperson-wrapper">
      <div class="label-wrapper">
        <label class="form-label lna" for="isIdVerifiedInPerson">
          {{ 'pages.client.isIdVerifiedInPerson' | translate }}
          <span class="required-field">*</span>
        </label>
        <app-tooltip text="userIsIdVerifiedInPerson" />
      </div>
      <div class="in-person-id">
        <div class="radio-wrapper">
          <input id="yes" [value]="true" type="radio" formControlName="isIdVerifiedInPerson" />
          <label for="active">{{ 'pages.client.yes' | translate }}</label>
        </div>
        <div class="radio-wrapper">
          <input id="no" [value]="false" type="radio" formControlName="isIdVerifiedInPerson" />
          <label for="inactive">{{ 'pages.client.no' | translate }}</label>
        </div>
      </div>
    </div>
    @if (isIdVerifiedInPerson?.value) {
    <div class="value-wrapper">
      <p class="form-label">
        {{ 'pages.client.general.verifiedByUser' | translate }}
      </p>
      <p class="form-value">{{ getVerifierFullName() || '-' }}</p>
    </div>
    }
  </div>
  <div class="third-grid">
    <div class="nationalDigitalId-wrapper">
      <div class="label-wrapper">
        <label class="form-label lna" for="nationalDigitalId">
          {{ 'pages.client.nationalDigitalId' | translate }}
                    @if (authenticationType === 'NationalId'){
                    <span class="required-field">*</span>
                    }
        </label>
        <app-tooltip text="userIdentidier" />
      </div>
      @if (authEmail?.value || authenticationType === 'Email'){
      <p>-</p>
      } @else {
      <input class="form-control lna" id="nationalDigitalId" [ngClass]="{
            invalid: this.shouldRenderError('nationalDigitalId') && nationalDigitalId?.errors
          }" type="text" pattern="[0-9-]*" [minlength]="11" [maxlength]="12" [readonly]="!!authEmail?.value"
        [disabled]="!!authEmail?.value" formControlName="nationalDigitalId"
        (keypress)="allowOnlyNumbersAndSingleDash($event)" (input)="validateSingleDash($event)"
        name="nationalDigitalId" />
      <div class="error-wrapper">
        @if (this.shouldRenderError('nationalDigitalId') && nationalDigitalId?.invalid) {
        @if (nationalDigitalId?.errors?.['required']) {
        <small class="error-message">
          {{ 'components.form.errorRequired' | translate }}
        </small>
        } @else if (nationalDigitalId?.errors?.['minlength']) {
        <small class="error-message">
          {{
          'components.form.minLength'
          | translate
          : { minLength: 11 }
          }}
        </small>
        }
        }
      </div>
      }
    </div>
    <div class="authEmail-wrapper">
      <div class="label-wrapper">
        <label class="form-label lna" for="authEmail">
          {{ 'pages.client.authEmail' | translate }}
          @if (authenticationType === 'Email'){
            <span class="required-field">*</span>
          }
        </label>
        <app-tooltip text="clientAuthEmail" />
      </div>
      @if (nationalDigitalId?.value || authenticationType === 'NationalId'){
      <p>-</p>
      } @else {
      <input class="form-control lna" id="authEmail" [ngClass]="{
            invalid: this.shouldRenderError('authEmail') && authEmail?.errors
          }" type="text" [readonly]="!!nationalDigitalId?.value" [disabled]="!!nationalDigitalId?.value"
        formControlName="authEmail" name="authEmail" />
      <div class="error-wrapper">
        @if (this.shouldRenderError('authEmail') && authEmail?.errors) {
        @if (authEmail?.errors?.['required']) {
        <small class="error-message">
          {{ 'components.form.errorRequired' | translate }}
        </small>
        } @else if (authEmail?.errors?.['invalidEmail']) {
        <small class="error-message">
          {{ 'components.form.invalidEmail' | translate }}
        </small>
        } @else if (authEmail?.errors?.['minlength']) {
        <small class="error-message">
          {{
          'components.form.minLength'
          | translate
          : {
          minLength: authEmail?.errors?.['minlength']['requiredLength']
          }
          }}
        </small>
        } @else if (authEmail?.errors?.['maxlength']) {
        <small class="error-message">
          {{
          'components.form.maxLength'
          | translate
          : {
          maxLength: authEmail?.errors?.['maxlength']['requiredLength']
          }
          }}
        </small>
        }
        }
      </div>
      }

    </div>
  </div>
  <div class="terms-row">
    <div class="value-wrapper">
      @if (client.agreementToPortalTerms) {
      <div class="inline">
        <img src="assets/images/check-icon.svg" alt="email verified" />
        <p class="terms-accepted form-value">
          {{ 'pages.client.general.agreementToPortalTerms' | translate }}
        </p>
      </div>
      } @else {
      <div class="inline">
        <img src="assets/images/warn-icon.svg" alt="email-not-verified.svg" />
        <p class="terms-not-accepted form-value">
          {{ 'pages.client.general.noAgreementToPortalTerms' | translate }}
        </p>
      </div>
      }
    </div>
  </div>
  <div class="second-grid">
    <div class="contact-info-heading full-span">
      <h4 class="m-0">
        {{ 'pages.client.general.contactInfo' | translate }}
      </h4>
      <app-tooltip [marginBottom]="false" text="userContactInfo" />
    </div>
    <div>
      <div class="label-wrapper">
        <label class="form-label lna" for="email">
          {{ 'pages.client.email' | translate }}
        </label>
        <app-tooltip text="userEmail" />
      </div>
      <input class="form-control lna" id="email" [ngClass]="{
            invalid: this.shouldRenderError('email') && email?.errors
          }" type="text" formControlName="email" name="email" />
      <div class="error-wrapper">
        @if (this.shouldRenderError('email') && email?.errors) {
        @if (email?.errors?.['invalidEmail']) {
        <small class="error-message">
          {{ 'components.form.invalidEmail' | translate }}
        </small>
        } @else if (email?.errors?.['minlength']) {
        <small class="error-message">
          {{
          'components.form.minLength'
          | translate
          : {
          minLength: email?.errors?.['minlength']['requiredLength']
          }
          }}
        </small>
        } @else if (email?.errors?.['maxlength']) {
        <small class="error-message">
          {{
          'components.form.maxLength'
          | translate
          : {
          maxLength: email?.errors?.['maxlength']['requiredLength']
          }
          }}
        </small>
        }
        }
      </div>
      <div class="lna-row email-verification-row no-margin">
        <div class="value-wrapper">
          @if (client.isEmailActivated) {
          <div class="inline">
            <img src="/assets/images/check-icon.svg" alt="email verified" />
            <p class="terms-accepted form-value">
              {{ 'pages.client.general.emailVerified' | translate }}
            </p>
          </div>
          } @else {
          <div class="inline">
            <img src="/assets/images/warn-icon.svg" alt="email not verified" />
            <p class="terms-not-accepted form-value">
              {{ 'pages.client.general.emailNotVerified' | translate }}
            </p>
          </div>
          }
        </div>
      </div>
    </div>
    <div>
      <div class="label-wrapper">
        <label class="form-label lna" for="phone">
          {{ 'pages.client.phone' | translate }}
        </label>
        <app-tooltip text="userPhone" />
      </div>
      <input class="form-control lna" id="phone" [ngClass]="{
            invalid: this.shouldRenderError('phone') && phone?.errors
          }" type="text" formControlName="phone" name="phone" />
      <div class="error-wrapper">
        @if (this.shouldRenderError('phone') && phone?.errors) {
        @if (phone?.errors?.['invalidPhone']) {
        <small class="error-message">
          {{ 'components.form.invalidPhone' | translate }}
        </small>
        } @else if (phone?.errors?.['minlength']) {
        <small class="error-message">
          {{
          'components.form.minLength'
          | translate
          : {
          minLength: phone?.errors?.['minlength']['requiredLength']
          }
          }}
        </small>
        } @else if (phone?.errors?.['maxlength']) {
        <small class="error-message">
          {{
          'components.form.maxLength'
          | translate
          : {
          maxLength: phone?.errors?.['maxlength']['requiredLength']
          }
          }}
        </small>
        }
        }
      </div>
    </div>
    <div class="address-wrapper">
      <div class="label-wrapper">
        <label class="form-label lna" for="address">
          {{ 'pages.client.address' | translate }}
        </label>
        <app-tooltip text="userAddress" />
      </div>
      <input class="form-control lna" id="address" [ngClass]="{
            invalid: this.shouldRenderError('address') && address?.errors
          }" type="text" formControlName="address" name="address" />
      <div class="error-wrapper">
        @if (this.shouldRenderError('address') && address?.errors) {
        @if (address?.errors?.['minlength']) {
        <small class="error-message">
          {{
          'components.form.minLength'
          | translate
          : {
          minLength: address?.errors?.['minlength']['requiredLength']
          }
          }}
        </small>
        } @else if (address?.errors?.['maxlength']) {
        <small class="error-message">
          {{
          'components.form.maxLength'
          | translate
          : {
          maxLength: address?.errors?.['maxlength']['requiredLength']
          }
          }}
        </small>
        }
        }
      </div>
    </div>
    <div>
      <p class="form-label">
        {{ 'pages.client.general.updatedAt' | translate }}
      </p>
      <p class="form-value">
        {{ formatDatetime(client.modifiedOn || '', true) }}
      </p>
    </div>
  </div>
</form>
} @else {
<div class="section">
  @if (client.clientType === 'Organization') {
  <h4>{{ 'pages.client.general.clientTitle' | translate }}</h4>
  } @else {
  <div class="heading-wrapper">
    <h4>{{ 'pages.client.general.title' | translate }}</h4>
    <div class="actions">
      @if (!client.isDeleted) {
      <button class="secondary editClient" (click)="setIsEditMode(true, true)">
        <img src="/assets/images/edit-icon.svg" alt="edit icon" />
        {{ 'pages.client.editClient' | translate }}
      </button>
      }
    </div>
  </div>
  }
  <div class="lna-row">
    <div class="value-wrapper">
      <div class="label-wrapper">
        <p class="form-label">
          {{ 'pages.client.general.name' | translate }}
        </p>
        <app-tooltip text="userName" />
      </div>
      <p class="form-value">{{ client.name }}</p>
    </div>
    <div class="value-wrapper">
      <div class="label-wrapper">
        <p class="form-label">
          {{ 'pages.client.general.surname' | translate }}
        </p>
        <app-tooltip text="userSurname" />
      </div>
      <p class="form-value">{{ client.surname }}</p>
    </div>
    <div class="value-wrapper">
      <div class="label-wrapper">
        <p class="form-label">
          {{ 'pages.client.general.birthday' | translate }}
        </p>
      </div>
      <p class="form-value">{{ formatDate(client.birthday ?? '') }}</p>
    </div>
  </div>
  <div class="lna-row" [ngClass]="{ 'section-divider': client.clientType === 'Organization' }">
    <div class="value-wrapper">
      <div class="label-wrapper">
        <p class="form-label">
          {{ (client.clientType === 'Organization' ? 'pages.client.general.countryShort' : 'pages.client.general.country') | translate }}
        </p>
        <app-tooltip text="userCountry" />
      </div>
      <p class="form-value">{{ client.country?.name || '' }}</p>
    </div>
    @if (client.clientType === 'Organization') {
    <div class="value-wrapper">
      <div class="label-wrapper">
        <p class="form-label">
          {{ 'pages.client.general.personalCode' | translate }}
        </p>
        <app-tooltip text="personalCode" />
      </div>
      <p class="form-value">{{ client.nationalDigitalId ?? '-' }}</p>
    </div>
    }
  </div>
  @if (client.clientType !== 'Organization') {
  <div class="lna-row">
    <div class="value-wrapper">
      <div class="label-wrapper">
        <p class="form-label">
          {{ 'pages.client.general.officialDocumentId' | translate }}
        </p>
        <app-tooltip text="officialDocumentId" />
      </div>
      <p class="form-value">{{ client.officialDocumentId ?? '-' }}</p>
    </div>
    <div class="value-wrapper">
      <div class="label-wrapper">
        <p class="form-label">
          {{ 'pages.client.general.inPersonVerification' | translate }}
        </p>
        <app-tooltip text="userInPersonVerification" />
      </div>
      <p class="form-value">
        {{ client.isIdVerifiedInPerson ? ('pages.client.general.yes' | translate) : ('pages.client.general.no' |
        translate)
        }}
      </p>
    </div>
    @if (isIdVerifiedInPerson?.value) {
    <div class="value-wrapper">
      <p class="form-label">
        {{ 'pages.client.general.verifiedByUser' | translate }}
      </p>
      <p class="form-value">{{ getVerifierFullName() || '-' }}</p>
    </div>
    }
  </div>
  <div class="lna-row auth-row mb-0">
    <div class="value-wrapper">
      <div class="label-wrapper">
        <p class="form-label">
          {{ 'pages.client.general.nationalDigitalId' | translate }}
        </p>
        <app-tooltip text="nationalDigitalId" />
      </div>
      <p class="form-value">{{ client.nationalDigitalId ?? '-' }}</p>
    </div>
    <div class="value-wrapper">
      <div class="label-wrapper">
        <p class="form-label">
          {{ 'pages.client.general.authEmail' | translate }}
        </p>
        <app-tooltip text="clientAuthEmail" />
      </div>
      <p class="form-value">{{ client.authEmail ?? '-' }}</p>
    </div>
  </div>
  <div class="terms-row">
    <div class="value-wrapper">
      @if (client.agreementToPortalTerms) {
      <div class="inline">
        <img src="assets/images/check-icon.svg" alt="email verified" />
        <p class="terms-accepted form-value">
          {{ 'pages.client.general.agreementToPortalTerms' | translate }}
        </p>
      </div>
      } @else {
      <div class="inline">
        <img src="assets/images/warn-icon.svg" alt="email-not-verified.svg" />
        <p class="terms-not-accepted form-value">
          {{ 'pages.client.general.noAgreementToPortalTerms' | translate }}
        </p>
      </div>
      }
    </div>
  </div>
  }
  <div class="contact-info-heading full-span">
    <h4 class="m-0">{{ 'pages.client.general.contactInfo' | translate }}</h4>
    <app-tooltip [marginBottom]="false" text="userContactInfo" />
  </div>
  <div class="lna-row no-margin">
    <div class="value-wrapper">
      <div class="label-wrapper">
        <p class="form-label">
          {{ 'pages.client.general.email' | translate }}
        </p>
        <app-tooltip text="userEmail" />
      </div>
      <p class="form-value">{{ client.email || '-' }}</p>
    </div>
    <div class="value-wrapper">
      <div class="label-wrapper">
        <p class="form-label">
          {{ 'pages.client.general.phone' | translate }}
        </p>
        <app-tooltip text="userPhone" />
      </div>
      <p class="form-value">{{ client.phone || '-' }}</p>
    </div>
  </div>
  <div class="lna-row email-verification-row">
    <div class="value-wrapper">
      @if (client.isEmailActivated) {
      <div class="inline">
        <img src="/assets/images/check-icon.svg" alt="email verified" />
        <p class="terms-accepted form-value">
          {{ 'pages.client.general.emailVerified' | translate }}
        </p>
      </div>
      } @else if (!client.isEmailActivated) {
      <div class="inline">
        <img src="/assets/images/warn-icon.svg" alt="email not verified" />
        <p class="terms-not-accepted form-value">
          {{ 'pages.client.general.emailNotVerified' | translate }}
        </p>
        @if (client.email && !client.isDeleted && client.authenticationType !== 'Unknown') {
        <p class="terms-not-accepted form-value mx-1 btn-link" (click)="resendEmailVerification()"
          (keydown.enter)="resendEmailVerification()" tabindex="0">
          {{ 'pages.client.general.resendEmailVerification' | translate }}
        </p>
        }
      </div>
      }
    </div>
  </div>
  <div class="lna-row">
    @if (client.clientType !== 'Organization') {
    <div class="value-wrapper">
      <div class="label-wrapper">
        <p class="form-label">
          {{ 'pages.client.general.address' | translate }}
        </p>
        <app-tooltip text="userAddress" />
      </div>
      <p class="form-value">{{ client.address || '-' }}</p>
    </div>
    }
    <div>
      <p class="form-label">
        {{ 'pages.client.general.updatedAt' | translate }}
      </p>
      <p class="form-value">
        {{ formatDatetime(client.modifiedOn || '', true) }}
      </p>
    </div>
  </div>
</div>
}

<app-confirm-modal title="unsavedChanges" bodyText="unsavedChangesBody" confirmText="confirm" denyText="cancelBack"
  [isOpen]="isConfirmModalOpen" (cancel)="isConfirmModalOpen = false" (confirm)="setIsEditMode(false, true)" />
